// extracted by mini-css-extract-plugin
module.exports = {"root":"accommodations-page_root__DWWnh"};